import React from "react";
import { Lock, ShieldCheck, Unlock } from "lucide-react";
import { Button } from "./ui/button";

const fmt = (iso) =>
  new Date(iso).toLocaleString("ro-RO", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

const LockRow = ({ l, onUnlock, busy }) => (
  <div
    className={`flex flex-col md:flex-row md:items-center gap-2 md:gap-4 px-4 py-3 border-t border-amber-200 ${
      l.active ? "" : "opacity-60"
    }`}
    data-testid={`recent-lock-${l.email}`}
  >
    <div className="flex-1 min-w-0">
      <div className="font-mono text-sm text-black truncate">
        {l.name ? `${l.name} · ` : ""}
        {l.email}
        {!l.account_exists && <span className="ml-2 text-[10px] uppercase text-zinc-500">cont inexistent</span>}
      </div>
      <div className="text-xs text-zinc-600 mt-0.5">
        Blocat la {fmt(l.locked_at)} · {l.fails_total} incercari gresite ·{" "}
        {l.buckets > 1 ? `${l.buckets} dispozitive blocate` : l.trusted ? "dispozitiv cunoscut" : "dispozitiv necunoscut"}
        {l.device ? ` · ${l.device}` : ""}
        {l.ip ? ` · IP ${l.ip}` : ""}
      </div>
    </div>
    {l.active ? (
      <div className="flex items-center gap-3 shrink-0">
        <span className="text-xs font-mono text-amber-800 inline-flex items-center gap-1">
          <Lock size={12} /> pana la {fmt(l.locked_until)}
        </span>
        <Button
          size="sm"
          onClick={() => onUnlock(l.email)}
          disabled={busy}
          className="rounded-sm bg-black hover:bg-zinc-800 text-white h-8 px-3"
          data-testid={`recent-lock-unlock-${l.email}`}
        >
          <Unlock size={12} className="mr-1" /> Deblocheaza
        </Button>
      </div>
    ) : (
      <span className="text-xs font-mono text-zinc-500 inline-flex items-center gap-1 shrink-0">
        <ShieldCheck size={12} /> blocare expirata
      </span>
    )}
  </div>
);

export const RecentLocks = ({ locks, onUnlock, busyEmail }) => {
  if (!locks.length) return null;
  const activeCount = locks.filter((l) => l.active).length;
  return (
    <div className="border border-amber-300 bg-amber-50 rounded-sm mb-6" data-testid="recent-locks-panel">
      <div className="px-4 py-3 flex items-center gap-2">
        <Lock size={14} className="text-amber-800" />
        <h2 className="font-display text-base font-bold tracking-tight text-black">Blocari recente</h2>
        <span className="text-xs font-mono text-amber-800" data-testid="recent-locks-active-count">
          {activeCount} active · ultimele 24h
        </span>
      </div>
      {locks.map((l) => (
        <LockRow key={`${l.email}-${l.locked_at}`} l={l} onUnlock={onUnlock} busy={busyEmail === l.email} />
      ))}
    </div>
  );
};
